import Constants from 'expo-constants';

import { logger as LOG } from '../../utils';

// ────────────────────────────────────────────────────────────────────────────────

export const reCaptchaLogger = LOG.extend('RECAPTCHA');

export function checkIfRecaptchaEnabled() {
  const envVars =
    Constants.manifest2?.extra?.expoClient?.extra ?? Constants.manifest?.extra;

  return envVars?.APP_ENV === 'production';
}
